<div class="container">
  <div class="item informational-risk row-margin" *ngIf="showColumn('informational')">
    {{ getSeverityCount('informational') }}
  </div>
  <div class="item low-risk row-margin" *ngIf="showColumn('low')">
    {{ getSeverityCount('low') }}
  </div>
  <div class="item medium-risk row-margin" *ngIf="showColumn('medium')">
    {{ getSeverityCount('medium') }}
  </div>
  <div class="item high-risk row-margin" *ngIf="showColumn('high')">
    {{ getSeverityCount('high') }}
  </div>
  <div class="item critical-risk row-margin" *ngIf="showColumn('critical')">
    {{ getSeverityCount('critical') }}
  </div>
</div>
